module.exports = __webpack_public_path__ + "img/scene_jungle_backlight@2x.94e9e270.png";